import _ from 'lodash';
import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { filter, first } from 'rxjs/operators';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { selectVirtualEventData } from 'app/virtual-event/features/data/data.selectors';
import { updateVirtualEventStatus } from 'app/virtual-event/features/data/data.actions';
import { VIRTUAL_EVENT_STATUS } from '../../virtual-event.enums';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public event$: any = this.store.pipe(select(selectVirtualEventData));

  public form: UntypedFormGroup;

  constructor(
    private store: Store<any>,
    private formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      'status': { value: null }
    });

    this.event$.pipe(
      filter((event: any) => !_.isNull(event.id)),
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((event) => {
      this.form.get('status').setValue({ value: event.runStatus });
      this.initStatus();
    });

    this.event$.pipe(
      filter((event: any) => !_.isNull(event.id)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(({ runStatus }) => {
      this.form.get('status').setValue({ value: runStatus });
    });
  }

  generateConfirmAction(name, initialState) {
    return DialogActions.openDialog({
      payload: {
        name,
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState
      }
    });
  }

  initStatus() {
    this.form.get('status').valueChanges.pipe(
      filter((value) => _.isNumber(value)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value) => {
      this.event$.pipe(first()).subscribe((event) => {
        switch(value) {
          case VIRTUAL_EVENT_STATUS.LOBBY:
          case VIRTUAL_EVENT_STATUS.START:
          case VIRTUAL_EVENT_STATUS.END:
            this.store.dispatch({
              type: updateVirtualEventStatus.type,
              payload: {
                id: event.id,
                status: value
              }
            });
            break;
        }
      });
    });
  }

}
